import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { browserHistory, Link, withRouter } from 'react-router';
import ShowProducts from '../components/products/ShowProducts';
import {
  clearAuthErrors, fetchCategories, fetchProducts, disableProduct, fetchOptions,
  fetchOptionGroups, clearProductsErrors
} from '../actions';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import RaisedButton from 'material-ui/RaisedButton';
import Pagination from '../components/home/Pagination';
import TextField from 'material-ui/TextField';
import { cyan900 } from 'material-ui/styles/colors';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  products: PropTypes.object.isRequired,
  query: PropTypes.object.isRequired,
  router: PropTypes.object,
};

class ProductsPage extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    // TODO: fix authentication - gabo
    if (!this.props.isAuthenticated) {
      this.props.dispatch(clearAuthErrors());
      browserHistory.goBack();
    }
    this.props.dispatch(clearProductsErrors());
    const selectLimit = { limit: 1000 };
    const query = this.props.query;
    const router = this.props.router;
    if (this.props.products.search && this.props.products.search.length > 0) {
      query.search = this.props.products.search;
    }
    if (!query.page) {
      query.page = 1;
      router.push({ pathname: '/products', query });
    } else {
      this.props.dispatch(fetchOptions(selectLimit));
      this.props.dispatch(fetchOptionGroups(selectLimit));
      this.props.dispatch(fetchCategories(selectLimit));
      this.props.dispatch(fetchProducts(query));
    }
  }
  onProductDisable(data) {
    this.props.dispatch(disableProduct(data));
  }
  handleSearchChange(e) {
    const products = this.props.products;
    const query = this.props.query;
    const router = this.props.router;
    const nextProductInput = e.target.value;
    const nextProduct = (nextProductInput !== '') ? nextProductInput : '';
    products.search = nextProduct;
    this.setState({
      products,
    });
    if (nextProduct.length > 0) {
      query.search = nextProduct;
    } else {
      delete query.search;
    }
    query.page = 1;
    router.push({ pathname: '/products', query });
    this.props.dispatch(fetchProducts(query));
  }
  navigation(route) {
    this.props.dispatch(fetchProducts(route));
  }
  render() {
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '1%',
      },
    };
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    return (
      <div className="products component" style={authPage}>
        <h2>Products</h2>
        <div className="content">
          <div className="action-buttons">
            <Link to="/products/new">
              <RaisedButton
                label="Add new Product"
                primary
              />
            </Link>
          </div>
          <div className="action-buttons top">
            <TextField
              floatingLabelText="Search by Name"
              floatingLabelStyle={styles.floatingLabelStyle}
              inputStyle={styles.inputStyle}
              value={this.props.products.search}
              onChange={this.handleSearchChange}
            />
            <Pagination
              paginationInfo={this.props.products.meta}
              pageCall={route => this.navigation(route)}
            />
          </div>
          <hr />
          <ShowProducts
            productsList={this.props.products}
            onProductDisable={data => this.onProductDisable(data)}
          />
        </div>
        <div className="action-buttons bottom">
          <Pagination
            paginationInfo={this.props.products.meta}
            pageCall={route => this.navigation(route)}
          />
        </div>
      </div>
    );
  }
}

ProductsPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

ProductsPage.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    products: state.products,
    options: state.options,
    optiongroups: state.optiongroups,
    query: ownProps.location.query,
  };
}

export default withRouter(connect(mapStateToProps)(ProductsPage));



// WEBPACK FOOTER //
// ./src/containers/ProductsPage.js